import moment from 'moment';
import pick from 'lodash/pick';

import { isoStringToUTCDate } from './dates';

export const defaultResultsPerPage = 12;

export default function getSearchQueryParams(query) {
  if (!query) return null;
  // Create the form values from the URL parameters
  // TODO: this is fugly
  const values = query;
  return (
    Object.keys(values)
      .filter((key) => !!values[key])
      // Ignore any we don't care about
      // TODO: infer this from values proptype?
      .filter((key) =>
        [
          'bookingEnabled',
          'id',
          'locationName',
          'locationLat',
          'locationLong',
          'locationSearchRadius',
          'locationSlug',
          'maxDate',
          'minDate',
          'name',
          'organiserId',
          'pastevents',
          'sort',
          'sortOption', // Not used by search service but by web client.
          'sport',
          'sportDistance',
          'sportDistances',
          'tag',
          'tags',
          'viewportNorthEastLat',
          'viewportNorthEastLong',
          'viewportSouthWestLat',
          'viewportSouthWestLong',
          'virtual',
        ].includes(key),
      )
      .reduce((obj, key) => {
        let value = values[key];
        // Handle numeric strings
        if (key === 'sport' || key === 'locationSearchRadius') {
          value = parseInt(value, 10);
        }
        if (key === 'sportDistance') {
          // Turn string IDs into single-element arrrays
          if (typeof value === 'string' || typeof value === 'number') {
            value = [value];
          }
          value = value.map((v) => parseInt(v, 10));
          // Distance invalid without sport
          if (!values.sport) {
            value = undefined;
          }
        }
        // Create date objects from string timestamps
        if (key === 'minDate' || key === 'maxDate') {
          value = moment.isMoment(value)
            ? value.toDate()
            : isoStringToUTCDate(value);
        }
        // Create a place-like object from the lat/long params if there is no location object
        // TODO: This should geocode coords to a real place object within filters container
        /* eslint-disable no-param-reassign */
        if (key === 'locationLong' && !values.location) {
          // TODO: This is awful
          delete values.viewportNorthEastLat;
          delete values.viewportNorthEastLong;
          delete values.viewportSouthWestLat;
          delete values.viewportSouthWestLong;
          obj.viewportNorthEastLat = undefined;
          obj.viewportNorthEastLong = undefined;
          obj.viewportSouthWestLat = undefined;
          obj.viewportSouthWestLong = undefined;
          obj.location = {
            name: values.locationName || 'Custom location',
            geometry: {
              location: {
                lat: () => values.locationLat,
                lng: () => values.locationLong,
              },
            },
            types: ['geolocation'],
          };
        }
        if (key === 'viewportNorthEastLat' && !values.location) {
          // TODO: See above
          delete values.locationLat;
          delete values.locationLong;
          obj.locationLat = undefined;
          obj.locationLong = undefined;
          obj.location = {
            name: values.locationName || 'Custom location',
            geometry: {
              viewport: {
                getNorthEast: () => ({
                  lat: () => values.viewportNorthEastLat,
                  lng: () => values.viewportNorthEastLong,
                }),
                getSouthWest: () => ({
                  lat: () => values.viewportSouthWestLat,
                  lng: () => values.viewportSouthWestLong,
                }),
              },
            },
            types: ['bounds'],
          };
        }
        if (key === 'sortOption') {
          value = parseInt(value, 10);
        }
        /* eslint-enable */
        return {
          ...obj,
          [key]: value,
        };
      }, {})
  );
}

export const whitelistInput = (query) => {
  return pick(query, [
    'excludeId',
    'explain',
    'includeEsQuery',
    'includeHits',
    'includeQuery',
    'locationLat',
    'locationLong',
    'locationSearchRadius',
    'maxDate',
    'minDate',
    'name',
    'noContent',
    'notViewportNorthEastLat',
    'notViewportNorthEastLong',
    'notViewportSouthWestLat',
    'notViewportSouthWestLong',
    'onlyAvailableEvents',
    'organiserId',
    'page',
    'pastevents',
    'popularityBoost',
    'radius',
    'resultsPerPage',
    'sort',
    'sport',
    'sportDistance',
    'sportDistances',
    'tag',
    'tags',
    'viewportNorthEastLat',
    'viewportNorthEastLong',
    'viewportSouthWestLat',
    'viewportSouthWestLong',
    'virtual',
  ]);
};
